import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { ConditionStatusScrollState } from '@/configuration/internal-redirect-states/condition-status-scroll-state'

export const useConditionStatusCollapseStore = defineStore('conditionStatusCollapseStore', () => {
    const collapsedState = reactive({
        recommendations: true,
        oilAnalyses: true,
        analysisComments: true,
        oilHistoricalTrends: true,
        visualInspections: true,
        componentComments: true,
    })

    const setCollapseScrollState = (state: ConditionStatusScrollState) => {
        switch (state) {
            case ConditionStatusScrollState.OilAnalysis:
                collapsedState.oilAnalyses = false
                break
            case ConditionStatusScrollState.AnalysisComments:
                collapsedState.analysisComments = false
                break
            case ConditionStatusScrollState.Recommendations:
                collapsedState.recommendations = false
                break
            case ConditionStatusScrollState.VisualInspection:
                collapsedState.visualInspections = false
                break
            case ConditionStatusScrollState.ComponentComments:
                collapsedState.componentComments = false
                break
            case ConditionStatusScrollState.Default:
                break
        }
    }

    const resetCollapsedState = () => {
        collapsedState.recommendations = true
        collapsedState.oilAnalyses = true
        collapsedState.analysisComments = true
        collapsedState.oilHistoricalTrends = true
        collapsedState.visualInspections = true
        collapsedState.componentComments = true
    }

    return {
        collapsedState,
        setCollapseScrollState,
        resetCollapsedState,
    }
})
